import ellipsis from './mixins/ellipsis';
import {
    sharpSansMedium,
    sharpSansSemibold,
    sharpSansBold,
} from './mixins/font';

export const displayExtraExtraSmall = sharpSansBold(32, 0, 40);
export const displayExtraSmall = sharpSansBold(40, 0, 48);
export const displaySmall = sharpSansBold(48, 0, 56);
export const displayMedium = sharpSansBold(60, 0, 72);
export const displayLarge = sharpSansBold(80, 0, 96);
export const displayExtraLarge = sharpSansBold(96, 0, 112);

export const headingExtraSmall = sharpSansBold(14, 0, 20);
export const headingSmall = sharpSansBold(16, 0, 24);
export const headingMedium = sharpSansBold(20, 0, 28);
export const headingLarge = sharpSansBold(24, 0, 32);
export const headingExtraLarge = sharpSansBold(40, 0, 48);

export const paragraphExtraSmall = sharpSansMedium(12, 0, 20);
export const paragraphSmall = sharpSansMedium(14, 0, 22);
export const paragraphMedium = sharpSansMedium(16, 0, 26);
export const paragraphLarge = sharpSansMedium(20, 0, 32);

export const labelExtraExtraSmall = sharpSansSemibold(10, 0, 12);
export const labelExtraSmall = sharpSansSemibold(12, 0, 20);
export const labelSmall = sharpSansSemibold(14, 0, 20);
export const labelMedium = sharpSansSemibold(16, 0, 24);
export const labelLarge = sharpSansSemibold(20, 0, 28);

export { ellipsis };
